import styles from './LeaderboardInfo.module.css'
import {useModalStore} from "../../../store/ModalStore.ts";
import LeaderboardModal from "../LeaderboardModal/LeaderboardModal.tsx";

const LeaderboardInfo = () => {

    const setOpen = useModalStore((state) => state.setOpen)

    const openModal = () => {
        setOpen(true)
    }

    return (
        <div className={styles.rewardsCard}>
            <div className={styles.rewardsContent}>
                <div className={styles.rewardsText}>
                    <p className={styles.rewardsTitle}>Награды за сентябрь</p>
                    <p className={styles.rewardsSubtitle}><span>Зарабатывай бисткоинов</span><br/> и получай награды</p>
                </div>
                <div className={styles.rewardsImage}></div>
            </div>
            <button onClick={openModal} className={styles.rewardsButton}>Список наград</button>
            <LeaderboardModal/>
        </div>
    )
}

export default LeaderboardInfo;